const merchantIcon =
  "https://file-v2.uchoice.pro/ads/common/img/single.png?x-oss-process=style/webp";
const merchantIconActive =
  "https://file-v2.uchoice.pro/ads/common/img/single2.png?x-oss-process=style/webp";

const commerorderManagementRoute: IRouteProps[] = [
  {
    path: "/commerorderManagement",
    name: "商单管理",
    meta: { icon: merchantIcon, activeIcon: merchantIconActive },
    routes: [
      {
        path: "/commerorderManagement/commerlist",
        name: "商单列表",
        component: "./commerorderManagement/commerlist"
      },
      {
        path: "/commerorderManagement/commerlist/createcommer/:type/:id",
        name: "创建商单",
        component: "./commerorderManagement/commerlist/createcommer",
        hideInMenu: true
      },

      {
        path: "/commerorderManagement/commerlist/viewProgress/:commercialOrderId",
        name: "查看进度",
        component: "./commerorderManagement/commerlist/viewProgress",
        hideInMenu: true
      },
      {
        path: "/commerorderManagement/workstation/:id",
        name: "工作台",
        component: "./commerorderManagement/workstation",
        hideInMenu: true
      }
    ]
  }
];

export default commerorderManagementRoute;
